module.exports = __webpack_public_path__ + "static/media/accessory20.6aa34917.webp";